import { Col, Nav, NavItem, NavLink } from "reactstrap";
import { AddProductSidebar } from "../../../../data/applications/ECommerce";
import { useAppDispatch, useAppSelector } from "../../../../reduxToolkit/hooks";
import { setNavId } from "../../../../reduxToolkit/reducers/eCommerce/addProductSlice";
import SvgIcon from "../../../../coreComponents/SvgIcon";

// Sidebar for the add product page, showing navigation icons and titles.
const Sidebar = () => {
  const { navId } = useAppSelector((state) => state.addProduct);
  const dispatch = useAppDispatch();

  return (
    <Col xxl="3" xl="4" className="box-col-4e sidebar-left-wrapper">
      <Nav pills className="sidebar-left-icons border-0" tabs>
        {/* Mapping through AddProductSidebar to dynamically render navigation items */}
        {AddProductSidebar.map((data, i) => (
          <NavItem key={i}>
            <NavLink className="border-0" active={navId === data.id ? true : false} onClick={() => dispatch(setNavId(data.id))}>
              <div className="nav-rounded">
                <div className="product-icons">
                  <SvgIcon className="stroke-icon" iconId={data.icon} />
                </div>
              </div>
              <div className="product-tab-content">
                <h5>{data.title}</h5>
                <p>{data.detail}</p>
              </div>
            </NavLink>
          </NavItem>
        ))}
      </Nav>
    </Col>
  );
};

export default Sidebar;